import { requestBuilder } from '../../../http/RequestBuilder';

export const useDeleteSyncteraExternalAccount = requestBuilder.mutation<
    { success: boolean },
    undefined,
    { syncteraExternalAccountId: string }
>({
    endpoint: ({ syncteraExternalAccountId }) =>
        `/api/admin/banking/external-account/${syncteraExternalAccountId}`,
    method: 'DELETE',
});

export const useDeleteAllSyncteraExternalAccountsForUser =
    requestBuilder.mutation<
        {
            deletedSyncteraExternalAccountIds: string[];
            failedSyncteraExternalAccountIds: string[];
        },
        undefined,
        { userId: string }
    >({
        endpoint: ({ userId }) =>
            `/api/admin/banking/external-account/user/${userId}`,
        method: 'DELETE',
    });
